import { ROLE_PERMISSIONS } from '../constants/roles';

export const usePermissions = (role: string) => {
  const hasPermission = (action: string) => {
    const rolePermissions = ROLE_PERMISSIONS[role as keyof typeof ROLE_PERMISSIONS];
    if (!rolePermissions) return false;
    return rolePermissions.actions[action as keyof typeof rolePermissions.actions] || false;
  };

  const canAccessTab = (tab: string) => {
    const rolePermissions = ROLE_PERMISSIONS[role as keyof typeof ROLE_PERMISSIONS];
    if (!rolePermissions) return false;
    return rolePermissions.tabs[tab as keyof typeof rolePermissions.tabs] || false;
  };

  return {
    hasPermission,
    canAccessTab
  };
}; 